<ep-panel panelType="box" title="Compare Policy Coverage & Premium">
  <div
    *ngIf="!(dataService.loadingCount == 0)"
    style="
      position: fixed;
      top: 50%;
      left: 50%;
      height: 40px;
      width: 40px;
      margin-left: -20px;
      color: rgba(0, 0, 0, 0.4);
    "
  >
    <i class="fa fa-pulse fa-ep-loading fa-2x"></i>
  </div>
  <ep-row>
    <div *ngIf="this.model.dataReady" class="col-12">
      <unity-switch
        inputId="diffOnly"
        label="Show Only Differences"
        [isChecked]="model.diffOnly"
        (checkboxChange)="model.diffOnly = !model.diffOnly"
      ></unity-switch>
    </div>
  </ep-row>
  <ep-row>
    <section *ngIf="this.model.dataReady" class="col-12" style="margin-top: 3px">
      <div
        class="table-responsive"
        style="max-height: 600px; overflow-y: scroll; border: 1px solid silver; background-color: white"
      >
        <table class="table" style="width: 100%; overflow-x: auto; white-space: nowrap">
          <tbody>
            <tr *ngFor="let item of itemData">
              <!--Title-->
              <td *ngIf="item.title === true" style="font-weight: 700; background-color: lightgrey">
                {{ item.label }}
              </td>

              <!--General Data-->
              <td
                *ngIf="
                  item.section == 'Contract' &&
                  !item.title &&
                  (!model.diffOnly || (model.diffOnly && item.hasDifference))
                "
                [style.background]="item.hasDifference && !model.diffOnly ? 'yellow' : 'white'"
              >
                <div style="display: inline-block; font-weight: 600; width: 225px">
                  {{ item.label }}
                </div>
                <div
                  *ngFor="let data of item.values; index as idx"
                  class="ep-truncate"
                  style="display: inline-block; text-align: right"
                  [style.width]="idx == 0 ? '150px' : '300px'"
                >
                  {{ data.value | epListPipe : [item.pipe] }}
                </div>
              </td>

              <!--Line Summary Data-->
              <td
                *ngIf="
                  item.lineCode &&
                  item.section == 'Summary' &&
                  (!model.diffOnly ||
                    (model.diffOnly &&
                      (item.values.totalPremValues.hasDifference ||
                        item.values.totalFeeValues.hasDifference ||
                        item.values.totalTaxValues.hasDifference)))
                "
              >
                <div
                  style="font-weight: 600"
                  [style.background]="item.values.hasDifference && !model.diffOnly ? 'yellow' : 'white'"
                >
                  {{ item.label }}
                </div>

                <!--Total Premium by Line-->
                <div
                  *ngIf="!model.diffOnly || (model.diffOnly && item.values.totalPremValues.hasDifference)"
                  [style.background]="item.values.totalPremValues.hasDifference && !model.diffOnly ? 'yellow' : 'white'"
                >
                  <div style="display: inline-block; font-weight: 600; width: 225px">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Premium
                  </div>
                  <div
                    *ngFor="let totalPremData of item.values.totalPremValues.values; index as idx"
                    class="ep-truncate"
                    style="display: inline-block; text-align: right"
                    [style.width]="idx == 0 ? '150px' : '300px'"
                  >
                    {{ totalPremData.value | epListPipe : [item.pipe] }}
                  </div>
                </div>

                <!--Total Fee by Line-->
                <div
                  *ngIf="!model.diffOnly || (model.diffOnly && item.values.totalFeeValues.hasDifference)"
                  [style.background]="item.values.totalFeeValues.hasDifference && !model.diffOnly ? 'yellow' : 'white'"
                >
                  <div style="display: inline-block; font-weight: 600; width: 225px">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Fee
                  </div>
                  <div
                    *ngFor="let totalFeeData of item.values.totalFeeValues.values; index as idx"
                    class="ep-truncate"
                    style="display: inline-block; text-align: right"
                    [style.width]="idx == 0 ? '150px' : '300px'"
                  >
                    {{ totalFeeData.value | epListPipe : [item.pipe] }}
                  </div>
                </div>

                <!--Total Tax by Line-->
                <div
                  *ngIf="!model.diffOnly || (model.diffOnly && item.values.totalTaxValues.hasDifference)"
                  [style.background]="item.values.totalTaxValues.hasDifference && !model.diffOnly ? 'yellow' : 'white'"
                >
                  <div style="display: inline-block; font-weight: 600; width: 225px">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Tax
                  </div>
                  <div
                    *ngFor="let totalTaxData of item.values.totalTaxValues.values; index as idx"
                    class="ep-truncate"
                    style="display: inline-block; width: 300px; text-align: right"
                    [style.width]="idx == 0 ? '150px' : '300px'"
                  >
                    {{ totalTaxData.value | epListPipe : [item.pipe] }}
                  </div>
                </div>
              </td>

              <!--Coverage Data-->
              <td
                *ngIf="
                  item.productCode &&
                  (!model.diffOnly ||
                    (model.diffOnly &&
                      (item.values.limitValues.hasDifference ||
                        item.values.deductValues.hasDifference ||
                        item.values.premValues.hasDifference)))
                "
              >
                <!--Label (Product Desc) and Limit values-->
                <div [style.background]="item.values.limitValues.hasDifference && !model.diffOnly ? 'yellow' : 'white'">
                  <div style="display: inline-block; font-weight: 600; width: 225px" class="ep-truncate">
                    {{ item.label }}
                  </div>
                  <ng-container *ngIf="!model.diffOnly || (model.diffOnly && item.values.limitValues.hasDifference)">
                    <div
                      *ngFor="let limitData of item.values.limitValues.values; index as idx"
                      class="ep-truncate"
                      style="display: inline-block; text-align: right"
                      [style.width]="idx == 0 ? '150px' : '300px'"
                    >
                      {{ limitData.value | epListPipe : [item.pipe] }}
                    </div>
                  </ng-container>
                </div>

                <!--Deduct values-->
                <div
                  *ngIf="!model.diffOnly || (model.diffOnly && item.values.deductValues.hasDifference)"
                  [style.background]="item.values.deductValues.hasDifference && !model.diffOnly ? 'yellow' : 'white'"
                >
                  <div style="display: inline-block; font-weight: 600; width: 225px">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Deductible
                  </div>
                  <div
                    *ngFor="let deductData of item.values.deductValues.values; index as idx"
                    class="ep-truncate"
                    style="display: inline-block; text-align: right"
                    [style.width]="idx == 0 ? '150px' : '300px'"
                  >
                    {{ deductData.value | epListPipe : [item.pipe] }}
                  </div>
                </div>

                <!--Prem values-->
                <div
                  *ngIf="!model.diffOnly || (model.diffOnly && item.values.premValues.hasDifference)"
                  [style.background]="item.values.premValues.hasDifference && !model.diffOnly ? 'yellow' : 'white'"
                >
                  <div style="display: inline-block; font-weight: 600; width: 225px">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Premium
                  </div>
                  <div
                    *ngFor="let premData of item.values.premValues.values; index as idx"
                    class="ep-truncate"
                    style="display: inline-block; text-align: right"
                    [style.width]="idx == 0 ? '150px' : '300px'"
                  >
                    {{ premData.value | epListPipe : [item.pipe] }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </ep-row>
</ep-panel>
<div class="modal-footer">
  <button unity-button type="button" (click)="close()" classes="primary">Close</button>
</div>
